package com.essntl.features.invoice.ui.addeditinvoice.components.content.day

import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import com.essntl.core.utils.utils.formatIntMoney
import com.essntl.uikit.components.checkbox.EsPrimaryCheckBox
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.icons.EsLargeIcon
import com.essntl.uikit.components.image.AsyncUrlIcon
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.*

@Composable
fun PaymentLinkDayServiceItem(
    state: InvoicingDayUiState.ServiceUiState,
    onCheckedChange: (Boolean) -> Unit,
    modifier: Modifier = Modifier,
) {
    Row(
        verticalAlignment = Alignment.CenterVertically,
        modifier = modifier,
    ) {
        EsPrimaryCheckBox(
            checked = if (state.status == ServiceInvoiceStatus.PAID ||
                state.status == ServiceInvoiceStatus.REMOVING
            )
                false else
                state.isChecked,
            onCheckedChange = onCheckedChange,
            enabled = state.status != ServiceInvoiceStatus.PAID &&
                state.status != ServiceInvoiceStatus.REMOVING,
        )

        Spacer(modifier = Modifier.width(1.spacing))

        if (state.iconUrl != null)
            AsyncUrlIcon(
                url = state.iconUrl,
                contentDescription = state.name,
                tint = MaterialTheme.esColorScheme.iconSecondary,
                modifier = Modifier
                    .size(24.dp),
            )
        else
            Spacer(modifier = Modifier.width(24.dp))

        Spacer(modifier = Modifier.width(1.spacing))

        Text(
            text = state.name,
            style = MaterialTheme.esTypography.p1Bold16,
            color = state.status.color(),
        )

        Spacer(modifier = Modifier.weight(1f))

        Text(
            text = "$${formatIntMoney(state.price)}",
            style = MaterialTheme.esTypography.p2Medium14,
            color = state.status.color(),
        )
        Spacer(modifier = Modifier.width(2.spacing))

        when (state.status) {
            ServiceInvoiceStatus.REMOVING ->
                EsLargeIcon(
                    res = EsIcons.Trash,
                    tint = Color.Red,
                )

            ServiceInvoiceStatus.PAID ->
                Text(
                    text = "Paid",
                    style = MaterialTheme.esTypography.p2Medium14,
                    color = MaterialTheme.esColorScheme.textSuccess,
                )

            ServiceInvoiceStatus.INVOICED,
            ServiceInvoiceStatus.NOT_INVOICED,
            -> Spacer(modifier = Modifier.width(24.dp))

            ServiceInvoiceStatus.ADDING ->
                EsLargeIcon(
                    res = EsIcons.AddSquare,
                    tint = MaterialTheme.esColorScheme.iconPrimary,
                )
        }
    }
}